import React from 'react'

import { Location, SearchScope } from 'features/common/types'

export interface LocationLabelProps {
  location: Location | undefined
  scope: SearchScope | undefined
  polygons: [number, number][][] | undefined
}

const LocationLabel: React.FC<LocationLabelProps> = ({ location, scope, polygons }) => {
  if (location) {
    return (
      <span className="text-base font-medium">{`${location?.name}${location?.city ? `, ${location?.city}` : ''}`}</span>
    )
  }
  if (scope) {
    return (
      <div className="flex items-center w-full gap-2">
        <span className="flex-1 text-base font-medium truncate">{scope.placeName}</span>
        {scope.distance && (
          <span className="text-sm font-medium text-blue-600">{`+${scope.distance}km`}</span>
        )}
      </div>
    )
  }
  if (polygons) {
    return <span className="text-base font-medium">{'Custom drawn area'}</span>
  }
  return null
}

export default LocationLabel
